// Renders the admin-configured filter fields for a page (see FilterConfigManager.js)
// inside that page's existing filter popup, in the configured order. The server picks
// the set from the user's tenant and primary team; there is nothing for the user to switch.
// Plain properties use `bindings`, which maps a pool key to the page's own state
// ([value, setValue]); keys without a binding are kept in customValues and sent as
// `custom_filters`. "Special" fields (street, team, city, ...) keep their bespoke JSX:
// the page passes a render function per key in `renderers`.
import React from "react";
import SearchInputField from "./SearchInputField";
import useFilterConfig from "../Hooks/useFilterConfig";

const ConfigurableFilterFields = ({
  page,
  bindings = {},
  renderers = {},
  customValues = {},
  onCustomChange = () => {},
  dataProperty = [],
}) => {
  const { fields } = useFilterConfig(page);

  return (
    <>
      {fields.map((field) => {
        if (field.kind === "special") {
          const render = renderers[field.key];
          return render ? <React.Fragment key={field.key}>{render()}</React.Fragment> : null;
        }

        const binding = bindings[field.key];
        const property = dataProperty?.find((data) => data?.name === field.hubspotProperty);
        const isSelect = field.inputType === "select" && property?.options?.length;
        const [value, setValue] = binding || [customValues[field.key] ?? "", (next) => onCustomChange(field.key, next)];

        return (
          <SearchInputField
            key={field.key}
            name={field.key}
            label={field.label}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            type={isSelect ? property.fieldType || "select" : false}
            options={isSelect ? property.options : []}
          />
        );
      })}
    </>
  );
};

export default ConfigurableFilterFields;
